var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 8.625L20 8L21.375 7.375L22 6L22.625 7.375L24 8L22.625 8.625L22 10L21.375 8.625ZM18.05 3.95L16 3L18.05 2.05L19 0L19.95 2.05L22 3L19.95 3.95L19 6L18.05 3.95ZM9 22C8.45 22 7.979 21.804 7.587 21.412C7.195 21.02 6.99933 20.5493 7 20H11C11 20.55 10.804 21.021 10.412 21.413C10.02 21.805 9.54933 22.0007 9 22ZM6 19C5.71667 19 5.479 18.904 5.287 18.712C5.095 18.52 4.99933 18.2827 5 18C5 17.7167 5.096 17.479 5.288 17.287C5.48 17.095 5.71733 16.9993 6 17H12C12.2833 17 12.521 17.096 12.713 17.288C12.905 17.48 13.0007 17.7173 13 18C13 18.2833 12.904 18.521 12.712 18.713C12.52 18.905 12.2827 19.0007 12 19H6ZM5.25 16C4.1 15.3167 3.18733 14.4 2.512 13.25C1.83667 12.1 1.49933 10.85 1.5 9.5C1.5 7.41667 2.22933 5.64567 3.688 4.187C5.14667 2.72833 6.91733 1.99933 9 2C11.0833 2 12.8543 2.72933 14.313 4.188C15.7717 5.64667 16.5007 7.41733 16.5 9.5C16.5 10.85 16.1627 12.1 15.488 13.25C14.8133 14.4 13.9007 15.3167 12.75 16H5.25ZM5.85 14H12.15C12.9 13.4667 13.4793 12.8083 13.888 12.025C14.2967 11.2417 14.5007 10.4 14.5 9.5C14.5 7.96667 13.9667 6.66667 12.9 5.6C11.8333 4.53333 10.5333 4 9 4C7.46667 4 6.16667 4.53333 5.1 5.6C4.03333 6.66667 3.5 7.96667 3.5 9.5C3.5 10.4 3.704 11.2417 4.112 12.025C4.52 12.8083 5.09933 13.4667 5.85 14Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip);
export default __webpack_public_path__ + "static/media/tip.2d15275c0f58026e5371832195fb59c7.svg";
export { ForwardRef as ReactComponent };